<app-import-nav />
<h5 class="mt-3">Import ESP NDCs</h5>

<form novalidate (keydown.enter)="onFormEnter($event)">
  <div class="row">
    <div class="col-12">
      <div class="alert alert-danger" *ngIf="hasError">
        There was a problem uploading the file.
        <ul class="mt-2">
          <li *ngFor="let error of errors">{{ error }}</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="mb-3">
        <label class="my-0"><strong>Client</strong></label>
        <div class="input-group">
          <select class="form-select" [(ngModel)]="formModel.clientId" name="clientId">
            <option [value]="null" [selected]="true"> -- Choose Client -- </option>
            <option *ngFor="let client of clients" [value]="client.id"> {{ client.humanizedName }} </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <app-file-upload
        [fileType]="'.csv'"
        [uploadButtonDisabled]="uploadButtonDisabled"
        (fileSelected)="onFileSelected($event)"
        (uploadStart)="onUploadStart()"
        (uploadCancel)="onUploadCancel()"
        (uploadError)="onUploadError()"
        (uploadComplete)="onUploadComplete($event)"
      />
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="mt-3 border p-3 rounded">
        <strong>File Requirements</strong>
        <ol class="mx-3 ps-2">
          <li class="py-2">
            Required fields
            <ul class="ps-2">
              <li><code>ndc</code> (required, 11 digit)</li>
              <li><code>expiration</code> (x number of days)</li>
              <li><code>action</code> (<strong>add</strong> or <strong>remove</strong>)</li>
            </ul>
          </li>
          <li class="py-2">
            Example file
            <div><small><strong>NOTE:</strong> Extra columns will be ignored</small></div>
            <div class="bg-light p-2 border w-100">
              <strong><code class="csv-header">ndc,expiration,action</code></strong><br />
              <code>00078064930,30,add</code><br />
              <code>12312312313,15,remove</code>
            </div>
          </li>
          <li class="py-2"><code>.csv</code> only</li>
        </ol>
      </div>
    </div>
  </div>
</form>